module.exports = __webpack_public_path__ + "static/media/img-home-succession.74172103.svg";